import {
  ComingSoonNextReleaseResponse,
  MovieDetailResponse,
  NowShowingResponse,
  QueryParams,
  ShowListResponse,
} from "types/api";

import { axiosBaseQuery } from "@picovico/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const movieApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Movie"],
  reducerPath: "movie",
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getNowShowing: builder.query<NowShowingResponse, QueryParams>({
      query: (params) => ({
        name: "now_showing",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    getNextRelease: builder.query<ComingSoonNextReleaseResponse, QueryParams>({
      query: (params) => ({
        name: "next_release",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    getComingSoon: builder.query<ComingSoonNextReleaseResponse, QueryParams>({
      query: (params) => ({
        name: "coming_soon",
        method: "GET",
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    getMovieDetail: builder.query<MovieDetailResponse, QueryParams>({
      query: ({ idx, ...params }) => ({
        name: "movie_detail",
        method: "GET",
        idx,
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    getShowDetailList: builder.query<ShowListResponse, QueryParams>({
      query: (params) => ({
        name: "show_detail_list",
        method: "GET",
        params: {
          ...params,
          paginate: false,
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetComingSoonQuery,
  useGetMovieDetailQuery,
  useGetNextReleaseQuery,
  useGetNowShowingQuery,
  useGetShowDetailListQuery,
  useLazyGetComingSoonQuery,
  useLazyGetMovieDetailQuery,
  useLazyGetNextReleaseQuery,
  useLazyGetNowShowingQuery,
  useLazyGetShowDetailListQuery,
} = movieApi;
